// extracted by mini-css-extract-plugin
module.exports = {"selectedProjectDetail":"styles__selectedProjectDetail--2mr99","dialog":"styles__dialog--2Np6A"};